import React from 'react';
import capitalize from 'capitalize';

import FormFrame from '../../common/FormFrame';
import AddLayerForm from './AddLayerForm';
import propTypes from './propTypes';

const title = 'Add Layer';

export const AddLayerComponent = (props) => {
  const { stackupType } = props;
  const description = `Followig materials will be added to the ${
    capitalize(stackupType)
  }`;
  return (
    <FormFrame label={title} description={description}>
      <AddLayerForm {...props} />
    </FormFrame>
  );
};

AddLayerComponent.propTypes = propTypes;

export default AddLayerComponent



// WEBPACK FOOTER //
// ./src/components/StackupDesign/AddLayer/AddLayerComponent.js